function MasterclassesWorkshops() {
    return (
        <div>
            <h2>Masterclasses/Workshops</h2>
            <p>To compliment conference program IETBHEC’26 program committee is offering Workshops. The intended workshops should fall within the scope of IETBHEC’26. Academics, researchers and practitioners wishing to facilitate workshops should submit a proposal with the following information.  </p>
            <div className="px-5">
                <ul>
                    <li>Masterclass/Workshop Title</li>
                    <li>Duration (2 hours suggested)</li>
                    <li>A Technical Description of the Masterclass Topic Area</li>
                    <li>A Brief Statement of the relevance of the Proposed Masterclass</li>
                </ul>
            </div>
        </div>
    )
}

export default MasterclassesWorkshops